export function getFlowQuoteFileName(marketName: string): string {
  return `flow_quote_${marketName.toLowerCase()}.pdf`;
}
